<template>
  <div class="page">
    <header-title :title="title"></header-title>
    <a-spin :spinning="pageLoading">
      <div class="s-filter-box">
        <a-form layout="inline" :model="bomForm">
          <a-form-item label="Finished Goods">
            <a-select
              v-model:value="bomForm.fgName"
              style="width: 200px"
              placeholder="Input or Choosing value "
              show-search
            >
              <a-select-option
                v-for="item in fgNames"
                :key="item"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Net ID">
            <a-select
              v-model:value="bomForm.netId"
              style="width: 200px"
              placeholder="Input or Choosing value "
              show-search
            >
              <a-select-option v-for="item in netIds" :key="item" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Operation ID">
            <a-select
              v-model:value="bomForm.opId"
              style="width: 200px"
              placeholder="Input or Choosing value "
              show-search
            >
              <a-select-option v-for="item in opIds" :key="item" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Valid From">
            <a-date-picker show-time v-model:value="bomForm.validFrom" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="find">
              <template #icon><SearchOutlined /></template>
              Find
            </a-button>
          </a-form-item>
        </a-form>
        <div class="button-box">
          <div class="btn-a">
            <a-button type="primary" :loading="addLoading" @click="bomAdd">
              <template #icon><DiffOutlined /></template>
              Add
            </a-button>
            <!-- <a-button type="primary" :disabled="isChange" @click="bomEdit">
            <template #icon><EditOutlined /></template>
            Edit
          </a-button> -->
            <a-button
              danger
              :disabled="!selectedRowKeys.length"
              @click="deleteAll"
            >
              <template #icon><DeleteOutlined /></template>
              Delete
            </a-button>
            <a-button @click="upload">
              <template #icon><UploadOutlined /></template>
              Upload
            </a-button>
          </div>
          <div class="btn-b">
            <a-button @click="applyFrom">Apply From</a-button>
            <a-select
              v-if="isShowJobIds && jobIds.length"
              v-model:value="selectedJobId"
              @change="jobIdChange"
              style="width: 200px; margin-left: 10px"
              placeholder="please select jobId"
              show-search
            >
              <a-select-option v-for="item in jobIds" :key="item" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>

      <div class="page-body" ref="pageBodyRef">
        <a-table
          :columns="columns"
          :row-key="(record) => record.id"
          :data-source="currentDatas"
          :loading="loading"
          :pagination="{ defaultPageSize: 20 }"
          :scroll="{ x: 'auto', y: tableYHeight }"
          size="small"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'isDriven'">
              <check-outlined v-if="record.isDriven" />
            </template>
            <template v-if="column.dataIndex === 'objectId'">
              <span @click="changeObjectId(record.objectId)">
                {{ record.objectId }}
                <plus-circle-filled style="color: #ebb766" />
              </span>
            </template>

            <template v-if="column.dataIndex === 'action'">
              <a-button type="link" size="small" @click="openEditModal(record)">
                <template #icon><edit-outlined /></template>
                Edit
              </a-button>
              <a-divider type="vertical" />

              <a-button type="link" size="small" @click="deleteRow(record.id)">
                <template #icon><delete-outlined /></template>
                Delete
              </a-button>
            </template>
          </template>
        </a-table>
      </div>
      <div class="fix-footer footer">
        <div class="button-bar">
          <a-button class="current" type="link" @click="init">
            <i class="iconfont icon-wuliaomingxi"></i>
            BOM
          </a-button>
          <a-button type="link" @click="goGroup">
            <i class="iconfont icon-data"></i>
            Mat. Group
          </a-button>
          <a-button type="link" @click="goMaterial">
            <i class="iconfont icon-materialsmanagement"></i>
            Material
          </a-button>
        </div>
      </div>
    </a-spin>
    <a-modal
      v-model:visible="dialogShow"
      width="1000px"
      :title="dialogTitle"
      @ok="saveCalendar"
      @cancel="bomConfirmLoading = false"
    >
      <a-spin :spinning="bomConfirmLoading">
        <a-form :model="ceForm">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item label="Region Code">
                <a-input v-model:value="ceForm.regionCode" disabled />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Object Type" :labelCol="{ span: 7 }">
                <a-select v-model:value="ceForm.objectType">
                  <a-select-option
                    :value="item"
                    v-for="item in objectTypes"
                    :key="item"
                  >
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Object ID" :labelCol="{ span: 7 }">
                <a-select v-model:value="ceForm.objectId">
                  <a-select-option
                    :value="item"
                    v-for="item in objectIds"
                    :key="item"
                  >
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Source Region" :labelCol="{ span: 7 }">
                <a-select v-model:value="ceForm.sourceRegionCode">
                  <a-select-option
                    :value="item"
                    v-for="item in sourceRegionCodes"
                    :key="item"
                  >
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Is Driven" :labelCol="{ span: 7 }">
                <a-switch v-model:checked="ceForm.isDriven" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Source Type" :labelCol="{ span: 7 }">
                <a-select v-model:value="ceForm.sourceType">
                  <a-select-option
                    :value="item"
                    v-for="item in sourceTypes"
                    :key="item"
                  >
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
  import { parseTime } from '@/utils'
  import HeaderTitle from '@/layout/header-title'
  import dayjs from 'dayjs'
  import {
    queryFGs,
    queryMaterialGroupIds,
    queryOpIds,
    querySourceRegionCodes,
    queryNetIds,
    getJobIds,
    queryWsBom,
    queryRegionCodes,
    saveWsBoms,
    validateSave,
    updateWsBom,
    delWsBom,
    testByItem,
    delWsBoms,
  } from '@/api/bom'
  import request from '@/utils/request'
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { createVNode } from 'vue'
  import { message, Modal } from 'ant-design-vue'
  import {
    SearchOutlined,
    DiffOutlined,
    EditOutlined,
    DeleteOutlined,
    UploadOutlined,
    CheckOutlined,
    PlusCircleFilled,
  } from '@ant-design/icons-vue'
  import { throttle } from '@/utils'
  export default {
    components: {
      HeaderTitle,
      SearchOutlined,
      DiffOutlined,
      EditOutlined,
      DeleteOutlined,
      UploadOutlined,
      CheckOutlined,
      PlusCircleFilled,
    },

    data() {
      return {
        title: 'Work Station BOM Maintenance',
        selectedRowKeys: [],
        selectedJobId: '',
        loading: false,
        pageLoading: false,
        bomConfirmLoading: false,
        isEdit: false,
        isChange: false,
        dialogShow: false,
        tableYHeight: 300,
        dialogTitle: 'BOM Item Create',
        addLoading: false,
        bomForm: {
          fgName: '',
          netId: '',
          opId: '',
          validFrom: dayjs(),
        },
        objectTypes: ['KIT', 'LC', 'SUB', 'WIP'],
        sourceTypes: ['Vendor', 'In House'],
        objectIds: [],
        sourceRegionCodes: [],
        ceForm: {
          regionCode: '',
          objectType: 'KIT',
          objectId: '',
          fgName: '',
          isDriven: false,
          sourceRegionCode: 0,
          sourceType: 'Vendor',
        },
        fgNames: [],
        netIds: [],
        opIds: [],
        jobIds: [],
        isShowJobIds: false,
        count: 0,
        currentDatas: [],
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: 60,
          },
          {
            title: 'Region',
            dataIndex: 'regionCode',
            width: 200,
          },
          {
            title: 'Object Type',
            dataIndex: 'objectType',
            width: 200,
          },
          {
            title: 'Object ID',
            dataIndex: 'objectId',
            width: 260,
          },
          {
            title: 'Name',
            dataIndex: 'fgName',
            width: 200,
          },
          {
            title: 'Is Driven',
            dataIndex: 'isDriven',
            width: 200,
          },

          {
            title: 'Source Region',
            dataIndex: 'sourceRegionCode',
            width: 240,
          },
          {
            title: 'Source Type',
            dataIndex: 'sourceType',
            width: 200,
          },
          {
            title: 'Valid To',
            dataIndex: 'validTo',
            width: 260,
            customRender({ text }) {
              return parseTime(text, '{y}/{m}/{d} {h}:{i}')
            },
          },
          {
            title: 'Operation',
            dataIndex: 'action',
            key: 'action',
            width: 260,
            fixed: 'right',
          },
        ],
      }
    },
    computed: {
      ...mapGetters({ netGroupId: 'user/currentNetGroup' }),
    },
    created() {
      this.init()
    },
    mounted() {
      setTimeout(this.setTableScrollH, 2000)
      window.addEventListener('resize', throttle(this.setTableScrollH, 500))
    },
    methods: {
      goGroup() {
        this.$router.push('/group')
      },
      changeTable() {
        this.$router({
          path: '/master',
          params: { type: 7 },
        })
      },
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys
      },
      setTableScrollH() {
        const obj = this.$refs.pageBodyRef
        const wWidth = document.documentElement.clientWidth
        const tableHeader = document.querySelector('.ant-table-header')
        const tHeadHeight = tableHeader ? tableHeader.clientHeight : 44
        const pagination = document.querySelector(
          '.ant-pagination.ant-table-pagination'
        )
        const pageHeight = pagination ? pagination.clientHeight : 27
        this.tableYHeight =
          obj.clientHeight - tHeadHeight - pageHeight - wWidth * 0.025
      },
      jobIdChange(v) {
        const startIdx = this.jobIds.findIndex((item) => item === v)
        const paramJobIds = this.jobIds.slice(startIdx)
        this.validateSelectedJobIds(paramJobIds.join(','))
        this.isShowJobIds = false
      },
      async validateSelectedJobIds(selectedJobIds) {
        const hide = message.loading('Loading..', 0)
        const _this = this
        try {
          const d = await request({
            url: '/api/masterdata/testPickRequest',
            method: 'post',
            data: {
              jobIds: selectedJobIds,
            },
          })

          if (d.errCode === '0000') {
            var changeJobIds = d.body.jobIds
            var count = d.body.count

            hide()
            Modal.confirm({
              title: 'Double confirmation is required',
              content:
                count === 0
                  ? `Note: JobID already has pick request and cannot be changed.`
                  : createVNode('div', {}, [
                      createVNode(
                        'div',
                        {},
                        `BOM for ${count} jobs ${changeJobIds} are to be changed.`
                      ),
                      createVNode(
                        'div',
                        {},
                        ' Note: Other JobID already has pick request and cannot be changed.'
                      ),
                    ]),
              width: 550,
              async onOk() {
                if (count != 0) {
                  _this.setSelectedJobIds(changeJobIds)
                }
              },
            })
          }
        } catch (e) {
          hide()
        }
      },

      async setSelectedJobIds(selectedJobIds) {
        const d = await request({
          url: '/api/masterdata/newBomByApplyFromByCommit',
          method: 'post',
          data: {
            jobIds: selectedJobIds,
            ...this.bomForm,
          },
        })

        if (d.errCode === '0000') {
          message.success('Success')
        } else {
          Modal.error({ title: 'Error', content: d.errMsg })
        }
      },
      init() {
        this.pageLoading = true
        axios
          .all([
            this.getFgNames(),
            this.getNetIds(),
            this.getOpIds(),
            this.getObjectIds(),
            this.querySourceRegionCodes(),
          ])
          .then(
            axios.spread(() => {
              this.pageLoading = false
            })
          )
      },
      find() {
        this.isEdit = false
        this.queryData()
        this.isChange = false
        this.isShowJobIds = false
      },
      async getFgNames() {
        const { body } = await queryFGs({ netGroupId: this.netGroupId })
        this.fgNames = body
        this.bomForm.fgName = this.fgNames[0]
      },
      async getNetIds() {
        const { body } = await queryNetIds({ netGroupId: this.netGroupId })
        this.netIds = body
        this.bomForm.netId = this.netIds[0]
      },
      async getOpIds() {
        const { body } = await queryOpIds({ netGroupId: this.netGroupId })
        this.opIds = body
        this.bomForm.opId = this.opIds[0]
      },
      async getJobIds() {
        const rawData = {
          fgName: this.bomForm.fgName,
          netId: this.bomForm.netId,
          opId: this.bomForm.opId,
        }
        const { body } = await getJobIds(rawData)
        this.jobIds = body
        this.isShowJobIds = true
        if (!body.length) {
          message.warning(
            'No information on the related job id list was found!'
          )
        }
      },
      applyFrom() {
        this.getJobIds()
      },
      changeObjectId(objectId) {
        this.$router.push({ path: 'group', query: { objectId } })
      },
      async queryData() {
        this.loading = true
        const { body } = await queryWsBom(this.bomForm)
        this.loading = false
        this.currentDatas = body
        this.count = this.currentDatas.length
      },
      // 新增
      async bomAdd() {
        const _this = this
        this.isShowJobIds = false
        const now = dayjs().valueOf()
        const vf = dayjs(this.bomForm.validFrom).valueOf()
        const day = 24 * 60 * 60 * 1000
        let isAfter = Math.round(vf / day) < Math.round(now / day)
        this.ceForm.id = ''
        if (this.currentDatas.length) {
          Modal.confirm({
            title: `Relevant BOM record exists with validity from ${dayjs(
              this.bomForm.validFrom
            ).format('YYYY-MM-DD HH:mm:ss')} , continue to overwrite`,
            width: 550,
            async onOk() {
              await _this.queryRegionCodes()
              _this.dialogShow = true
            },
          })
        } else if (isAfter) {
          message.error('Please set a date no earlier than today!')
          return
        } else {
          await _this.queryRegionCodes()
          _this.dialogShow = true
        }
        this.dialogTitle = 'BOM Item Create'
      },
      // 编辑
      async openEditModal(row) {
        this.ceForm = { ...row }
        this.ceForm.startTime = row.startTime ? new Date(row.startTime) : null
        this.ceForm.endTime = row.endTime ? new Date(row.endTime) : null
        const hide = message.loading('Loading..', 0)
        await this.queryRegionCodes()
        hide()
        this.dialogShow = true
      },
      // 删除
      async deleteRow(id) {
        const _this = this
        Modal.confirm({
          title: `删除这条记录?`,
          width: 550,
          async onOk() {
            const hide = message.loading('正在删除..', 0)
            try {
              const rawData = {
                id: id,
                ..._this.bomForm,
              }
              const result = await delWsBom(rawData)
              if (result.errCode === '0000') {
                message.loading('删除成功')
                _this.queryData()
              }
              await testByItem(rawData)

              hide()
            } catch (e) {
              hide()
            }
          },
        })
      },
      // 删除全部
      async deleteAll() {
        this.isShowJobIds = false
        const _this = this
        Modal.confirm({
          title: `There are ${this.selectedRowKeys.length} BOM items to be deleted, double confirm is required`,
          width: 550,
          async onOk() {
            const hide = message.loading('Deleting..', 0)
            try {
              const rawData = _this.currentDatas.filter((item) =>
                _this.selectedRowKeys.includes(item.id)
              )
              await delWsBoms(rawData)
              hide()
              _this.queryData()
            } catch (e) {
              hide()
            }
          },
        })
      },
      upload() {
        this.$router.push({ path: '/master', query: { type: 18 } })
        this.isShowJobIds = false
      },
      goMaterial() {
        this.$router.push({ path: '/master', query: { type: 7 } })
        this.isShowJobIds = false
      },
      async saveCalendar() {
        const _this = this
        this.bomConfirmLoading = true
        try {
          let news = []
          let arr = this.ceForm.regionCode.split(',')
          for (var i = 0; i < arr.length; i++) {
            news[i] = {
              validTo: '',
              ...this.ceForm,
              ...this.bomForm,
              regionCode: arr[i],
              validFrom: dayjs().valueOf(),
            }
          }

          let d = null

          if (news[0].id) {
            d = await updateWsBom(news)
          } else {
            d = await saveWsBoms(news)
          }

          if (d.errCode === '0000') {
            this.queryData() //[CXHKP-80]-添加完成后，页面不自动刷新
            _this.dialogShow = false
          }

          this.bomConfirmLoading = false
          await validateSave(news)
        } catch (e) {
          this.bomConfirmLoading = false
        }
      },
      async queryRegionCodes() {
        this.addLoading = true
        try {
          const { body } = await queryRegionCodes({
            netId: this.bomForm.netId,
            opId: this.bomForm.opId,
          })

          this.ceForm.regionCode = body.join(',')
          this.addLoading = false
          return Promise.resolve()
        } catch (e) {
          this.addLoading = false
          message.error(e)
        }
      },
      async getObjectIds() {
        const { body } = await queryMaterialGroupIds({
          netGroupId: this.netGroupId,
        })
        this.objectIds = body
        this.ceForm.objectId = body.length ? body[0] : ''
      },
      async querySourceRegionCodes() {
        const { body } = await querySourceRegionCodes({
          netGroupId: this.netGroupId,
        })
        this.sourceRegionCodes = body
        this.ceForm.sourceRegionCode = body.length ? body[0] : ''
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';

  .page-body {
    height: calc(100vh - 229px);
    overflow: hidden;
  }
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
    .button-box {
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      margin: 0 -5px;
      .btn-a {
        .ant-btn {
          margin: 0 5px;
        }
      }
    }
  }
  .footer {
    background: #eeeff3;
    border-top: 1px solid #dadbe0;
    height: 50px;

    display: flex;
    align-items: center;
    .button-bar {
      margin: 0 auto;
      .ant-btn {
        padding: 0 50px;
        color: #333;
        &.current {
          color: @primary-color;
        }
      }

      i {
        display: block;
        font-size: 20px;
        line-height: 1;
      }
      :deep(span) {
        font-size: 12px;
      }
    }
  }
  .fix-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
